import {State} from "../state";
import type {BookingflowStateMachine} from "../../bookingflowstatemachine";
import type {notAvailableActions, NotAvailableStateActions} from "./notavailableState.types";
import {notAvailableStateActions} from "./notavailableState.types";
import { CustomerEmail, BasisType } from "@raskrask-dk/raskrask-utils";


const NOT_AVAILABLE_STATE = "NOT_AVAILABLE";
export default class NotAvailableState extends State<NotAvailableStateActions, typeof NOT_AVAILABLE_STATE> {
  public readonly type = NOT_AVAILABLE_STATE;
  private _email: CustomerEmail | undefined;
  private _basisTypes: BasisType[] | undefined;

  constructor(bookingflowStateMachine: BookingflowStateMachine, email?: CustomerEmail) {
    super(bookingflowStateMachine);
    this._email = email;
  }

  public unset = (action: NotAvailableStateActions): void => {
    // you see nothing
  };

  public getActions = (): notAvailableActions[] => notAvailableStateActions.filter((action) => new action(this).isDoable());

  public doAction = (action: NotAvailableStateActions): NotAvailableState => {
    switch (action.type) {
      case "SET_SIGN_UP_EMAIL":
        this._email = action.data;
        return this;
      case "SET_BASISTYPES":
        this._basisTypes = action.data;
        return this;
      default:
        throw new Error("Unhandled Exception");
    }
  };

  public get email(): CustomerEmail | undefined {
    return this._email;
  }
  public get basisTypes(): BasisType[] | undefined {
    return this._basisTypes;
  }

  public getData(): {email: CustomerEmail | undefined; basisTypes: BasisType[] | undefined} {
    return {email: this.email, basisTypes: this.basisTypes};
  }
}
